export const PAGE_PATH = '/oplata/:id';
export const PAGE_PATH_DYNAMIC = (id: string) => `/oplata/${id}`;
